const products = {
  free: {
    id: 'free',
    name: 'Free',
    theme: 'pink',
    plans: {
      monthly: {
        id: 'free',
        price: 0,
        currency: 'usd',
        period: 'month'
      }
    },
    pricingComment: 'free forever',
    includes: [], // Includes the features of these plans
    displayFeatures: [ // Plus these extra features
      'single-user',
      'free-qrs-limit',
      'free-projects-limit',
      'free-emails-limit',
      'unlimited-views',
      'qr-code-studio-acess',
      'microsite-studio-access',
      'single-page-microsite',
      'custom-url',
      'experience-builder',
      'customer-crm',
      'email-capture'
    ],
    emailTemplate: 'd-9692df75f3b44b2998af751e8453c7c2'
  },

  grow: {
    id: 'grow',
    name: 'Grow',
    theme: 'blue',
    trial_days: 14,
    plans: {
      monthly: {
        id: 'grow-monthly',
        price: 1900,
        currency: 'usd',
        period: 'month'
      },
      annual: {
        id: 'grow-annual',
        price: 18000,
        currency: 'usd',
        period: 'year'
      },
      'monthly-gbp': {
        id: 'grow-monthly-gbp',
        price: 1900,
        currency: 'gbp',
        period: 'month'
      },
      'annual-gbp': {
        id: 'grow-annual-gbp',
        price: 12700,
        currency: 'gbp',
        period: 'year'
      }
    },
    pricingComment: null,
    includes: ['free'],
    displayFeatures: [
      'single-user',
      'grow-qrs-limit',
      'grow-projects-limit',
      'grow-emails-limit',
      'dynamic-qrs',
      'qr-customization',
      'qr-code-logos',
      'qr-code-analytics',
      'multi-page-microsite',
      'interactive-widgets',
      'custom-templates',
      'custom-fonts',
      'custom-meta-data',
      'flow-analytics',
      'integrations',
      'email-integrations',
      'remove-faraday-branding',
      'support'
    ],
    keyPoints: [
      'Dynamic QR Studio',
      'Remove tapkit branding',
      'Smart integrations'
    ],
    emailTemplate: 'd-e9acb814fc794448ba3b642a1181d0fe'
  },

  pro: {
    id: 'pro',
    name: 'Pro',
    theme: 'purple',
    trial_days: 14,
    plans: {
      'cartloop-pro-monthly': {
        id: 'cartloop-pro-monthly',
        price: 4800,
        currency: 'usd',
        period: 'month',
        trial_days: 60
      },
      monthly: {
        id: 'pro-monthly',
        price: 4800,
        currency: 'usd',
        period: 'month'
      },
      annual: {
        id: 'pro-annual',
        price: 43200,
        currency: 'usd',
        period: 'year'
      },
      'monthly-gbp': {
        id: 'pro-monthly-gbp',
        price: 3700,
        currency: 'gbp',
        period: 'month'
      },
      'annual-gbp': {
        id: 'pro-annual-gbp',
        price: 33000,
        currency: 'gbp',
        period: 'year'
      },

      // admin plan
      admin: {
        id: 'pro-admin-trial',
        price: 0,
        period: 'trial',
        adminOnly: true
      }
    },
    pricingComment: null, // 'save 60% yearly'
    includes: ['grow', 'free'],
    displayFeatures: [
      'single-user',
      'pro-qrs-limit',
      'pro-projects-limit',
      'pro-emails-limit',
      'smart-result-frames',
      'custom-domain-hosting',
      'view-raw-data',
      'placements',
      'fb-pixel',
      'zapier'
    ],
    keyPoints: [
      'Custom domains',
      'Raw data views',
      'Unlimited caps'
    ],
    emailTemplate: 'd-fb9835a7184e46a69deec796c71ef0fc'
  },

  'app-sumo-pro': {
    id: 'app-sumo-pro',
    name: 'App Sumo Pro',
    theme: 'purple',
    plans: {
      annual: {
        id: 'app-sumo-pro-annual',
        price: 0,
        currency: 'gbp',
        period: 'year'
      }
    },
    pricingComment: null, // 'save 60% yearly'
    includes: ['grow', 'free'],
    displayFeatures: [
      'single-user',
      'pro-projects-limit',
      'pro-emails-limit',
      'smart-result-frames',
      'custom-domain-hosting',
      'view-raw-data',
      'fb-pixel',
      'zapier'
    ],
    emailTemplate: 'd-fb9835a7184e46a69deec796c71ef0fc'
  },

  business: {
    id: 'business',
    name: 'Business',
    theme: 'blue',
    plans: {
      monthly: {
        id: 'business-monthly',
        price: 12000,
        currency: 'usd',
        period: 'month'
      },
      annual: {
        id: 'business-annual',
        price: 115200,
        currency: 'usd',
        period: 'year'
      },
      'monthly-gbd': {
        id: 'business-monthly-gbp',
        price: 9200,
        currency: 'gbp',
        period: 'month'
      },
      'annual-gbd': {
        id: 'business-annual-gbp',
        price: 88800,
        currency: 'gbp',
        period: 'year'
      },

      // admin plan
      admin: {
        id: 'business-admin-trial',
        price: 0,
        period: 'trial',
        adminOnly: true
      }
    },
    pricingComment: null, // 'save 60% yearly'
    includes: ['pro', 'grow', 'free'],
    displayFeatures: [
      'unlimited-views',
      'unlimited-leads',
      'unlimited-projects',
      'custom-domain-hosting'
    ],
    keyPoints: [
      'Branded QR codes',
      'Real-time analytics',
      'Transport customers online'
    ],
    emailTemplate: 'd-191d537345a6478daacf9edbe20ac02d'
  },

  premium: {
    id: 'premium',
    name: 'Premium',
    theme: 'cyan',
    byRequest: true,
    plans: {
    },
    pricingComment: null,
    includes: ['business', 'pro', 'grow', 'free'],
    displayFeatures: [
      '10-plus-users',
      'teams-and-permissions',
      'mfa-logins',
      'custom-billing',
      'agency-management',
      'dedicated-account-management',
      'coaching'
    ],
    emailTemplate: 'd-2cfa2609fa23408db90ed6213ff5f874'
  },

  'base-premium': {
    id: 'base-premium',
    name: 'Base Premium',
    theme: 'cyan',
    enterpriseProduct: true,
    plans: {
      'monthly-gbp': {
        id: 'base-premium-monthly-gbp',
        price: 60000,
        currency: 'gbp',
        period: 'month',
        exclusiveVat: true,
        enterprise: true
      },
      // admin plan
      admin: {
        id: 'premium-admin-trial',
        price: 0,
        period: 'trial',
        adminOnly: true,
        enterprise: true
      }
    },
    pricingComment: null,
    includes: ['business', 'grow', 'free', 'pro'],
    displayFeatures: [
      'multiple-users',
      'teams-and-permissions',
      'coaching-and-ac-management',
      'unlimited-subdomains'
    ],
    emailTemplate: 'd-5ac279c4069b43ce81d81cf9d8789301'
  }
}

const plans = {}

Object.keys(products).forEach(productId => {
  const product = products[productId]
  // Pre-collate full list of features for each product
  product.features = {}
  product.displayFeatures.forEach(feature => {
    product.features[feature] = true
  })
  if (product.includes) {
    product.includes.forEach(includedProduct => {
      products[includedProduct].displayFeatures.forEach(feature => {
        product.features[feature] = true
      })
    })
  }

  // Set up plan dictionary:
  Object.values(product.plans).forEach(plan => {
    plans[plan.id] = {
      ...plan,
      product: productId
    }
  })
})

exports.products = products
exports.plans = plans
